import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Owl silhouette uses the ★1 tier art. The active rendering for
// Sage Owl goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/sage_owl_3tier.jpg.
export const Owl = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/owl-1.png" size={size} alt="owl" />
)
